<template>
	<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" @click="$emit('click')">
		<g fill-rule="nonzero" fill="none">
			<path d="M10 19.412A9.412 9.412 0 1 1 10 .588a9.412 9.412 0 0 1 0 18.824z" stroke="#F09C2B" fill="#F09C2B"/>
			<path d="M9.291 11.093v-.318c0-.365.066-.668.199-.91s.365-.492.696-.75c.394-.312.649-.554.763-.727a1.09 1.09 0 0 0 .172-.616c0-.278-.093-.492-.279-.641-.185-.15-.452-.224-.8-.224-.315 0-.607.045-.875.134-.269.09-.53.197-.786.323l-.417-.875a4.376 4.376 0 0 1 2.162-.561c.65 0 1.165.159 1.546.477.381.318.572.757.572 1.317 0 .249-.036.47-.11.664a1.905 1.905 0 0 1-.33.554c-.147.176-.402.404-.763.686-.308.242-.515.443-.619.602-.104.159-.157.373-.157.641v.224h-.974zm-.204 1.585c0-.5.244-.75.731-.75.239 0 .42.065.547.196.126.131.189.316.189.554 0 .236-.064.422-.192.56-.127.137-.309.206-.544.206-.235 0-.416-.067-.542-.201-.126-.135-.189-.323-.189-.565z" fill="#FFF"/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'circle-info-icon',
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/shared/components/icons/circle-info-icon.vue